import { useCallback, useEffect, useRef, useState } from 'react';
import './main.css';
import '../App.css';
import { useSpring, animated } from 'react-spring';
import '@fortawesome/fontawesome-free/css/all.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { handleVibration, changeNum, changeUnitsOrigial, changeUnits } from './common/function';
import { changeAlramModal, changeEnergy, changeGold, checkDuplicateLogins, checkLimitUpgrade, checkLimitUpgradeValue, checkTapUpgrade, checkTapUpgradeValue } from '../store';
import axios from 'axios';
import { BeatLoader } from "react-spinners";
import MessageModal from './messageModal';
import { useTranslation } from "react-i18next";
import SlotCounter from 'react-slot-counter';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FreeMode, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import useWindowSize from '../hook/useWindowSize'

let jackpotCheck = false

function Main() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => { return state.JWT.value })
    let jackpot = useSelector((state) => { return state.jackpot })
    let mySkin = useSelector((state) => { return state.mySkin })
    let gold = useSelector((state) => { return state.gold.value })
    let energy = useSelector((state) => { return state.energy.value })
    let tapUpgradeValue = useSelector((state) => { return state.tapUpgradeValue.value })
    let limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    let JackpotImg = useSelector((state) => { return state.JackpotImg })
    let myData = useSelector((state) => { return state.myData })
    let circleImg = useSelector((state) => { return state.circleImg.value })

    let haptic = useSelector((state) => { return state.haptic.value })
    let sound = useSelector((state) => { return state.sound.value })

    let dispatch = useDispatch()
    let navigate = useNavigate()

    const { Rwidth, Rheight } = useWindowSize();

    const imageRef = useRef(null);
    const [infoModal, setInfoModal] = useState(false)
    const [jackpotWhale, setJackpotWhale] = useState(false)
    const [showGoldText, setShowGoldText] = useState(false);
    const [jackpotAmt, setJackpotAmt] = useState(0)
    const [textPosition, setTextPosition] = useState({ top: 50, left: 60 });
    const [upgrade, setUpgrade] = useState([])
    const [banner, setBanner] = useState([])

    const [message, setMessage] = useState("");

    const imgRef = useRef(null)
    const [adsHeightState, setAdsHeightState] = useState(0);

    const [clickBudgetId, setClickBudgetId] = useState("")

    const [centerImgLoad, setCenterImgLoad] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            const windowHeight = window.innerHeight;

            if (windowHeight <= 580) {
                setAdsHeightState(1)
            } else if (windowHeight <= 650) {
                setAdsHeightState(2)
            } else if (windowHeight <= 720) {
                setAdsHeightState(3)
            } else {
                setAdsHeightState(0)
            }
        };

        handleResize();

    }, [Rheight]);

    useEffect(() => {
        UpgradeData()
        BannerData()
    }, [])

    const UpgradeData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/upgrade', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setUpgrade(tmp?.data?.up ?? 0)
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const BannerData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/ad', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setBanner(tmp?.data?.ad ?? [])
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    // 배경 기울기 애니메이션 설정
    const [tiltStyle, tiltApi] = useSpring(() => ({
        transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)',
        config: { tension: 600, friction: 10 },
    }));

    // 햄스터 점프 애니메이션 설정
    const [jumpStyle, jumpApi] = useSpring(() => ({
        transform: 'translate(-50%, -50%) translateY(0px)', // 초기 위치
        config: { tension: 200, friction: 12 },
    }));

    const [hearts, setHearts] = useState([]);

    const handlePointerDown = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();

        if (haptic) handleVibration(1) // 버튼 클릭 시 진동 실행
        if (sound) ClickAudio()

        const { clientX, clientY } = event;

        const rect = imgRef.current.getBoundingClientRect();
        const imageX = rect.left; // 이미지의 x 위치
        const imageY = rect.top;

        const newHeart = {
            id: Date.now() + Math.random(),
            x: clientX - imageX - 25,
            y: clientY - imageY - 60,
        };

        if (energy > 0) {
            const newGold = gold + tapUpgradeValue;
            const newEnergy = energy - 1;

            // 골드와 에너지 상태 업데이트
            dispatch(changeGold(newGold));
            dispatch(changeEnergy(newEnergy));

            // 로컬스토리지에 저장할 로그 항목 생성
            const newLogGold = {
                amount: tapUpgradeValue,
                balance: newGold,
                time: new Date()
            };
            const newLogEnergy = {
                amount: 1,
                balance: newEnergy,
                time: new Date()
            };

            // 기존 골드 로그 배열을 불러오고, 새로운 항목 추가
            const storedGoldLogs = JSON.parse(localStorage.getItem("goldLogs")) || [];
            storedGoldLogs.push(newLogGold);

            // 기존 에너지 로그 배열을 불러오고, 새로운 항목 추가
            const storedEnergyLogs = JSON.parse(localStorage.getItem("energyLogs")) || [];
            storedEnergyLogs.push(newLogEnergy);

            // 로컬스토리지에 업데이트된 로그 배열을 저장
            localStorage.setItem("goldLogs", JSON.stringify(storedGoldLogs));
            localStorage.setItem("energyLogs", JSON.stringify(storedEnergyLogs));

            if (storedGoldLogs.length == 10) {
                GoldBulk(storedGoldLogs)
                localStorage.removeItem("goldLogs");
            }
            else if (storedGoldLogs.length > 10) {
                const remainingLogs = storedGoldLogs.slice(10);
                localStorage.setItem("goldLogs", JSON.stringify(remainingLogs));
            }
            if (storedEnergyLogs.length == 10) {
                EnergyBulk(storedEnergyLogs)
                localStorage.removeItem("energyLogs");
            }
            else if (storedEnergyLogs.length > 10) {
                const remainingLogs = storedEnergyLogs.slice(10);
                localStorage.setItem("energyLogs", JSON.stringify(remainingLogs));
            }

            checkTimeAndLog() // 잭팟 확률 체크
        }

        setHearts((prevHearts) => [...prevHearts, newHeart]);

        setTimeout(() => {
            setHearts((prevHearts) => prevHearts.filter((h) => h.id !== newHeart.id));
        }, 1000);

        applyTilt(event); // 배경 기울기 적용
        applyJump(); // 햄스터 점프 애니메이션 실행
    }, [gold, energy, jackpot]);


    const GoldBulk = async (storedGoldLogs) => {
        const tg = window.Telegram.WebApp;
        tg.ready();

        await axios.post(process.env.REACT_APP_API + '/api/gold/bulk', {
            goldBulk: storedGoldLogs
        }, {
            headers: { Authorization: `Bearer ${tg.initData}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const EnergyBulk = async (storedEnergyLogs) => {
        const tg = window.Telegram.WebApp;
        tg.ready();
        await axios.post(process.env.REACT_APP_API + '/api/energy/bulk', {
            energyBulk: storedEnergyLogs
        }, {
            headers: { Authorization: `Bearer ${tg.initData}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const applyTilt = (e) => {
        const card = imageRef.current;
        if (!card) return;

        const { width, height, left, top } = card.getBoundingClientRect();
        const x = e.clientX - left - width / 2;
        const y = e.clientY - top - height / 2;

        const rotateX = (-y / 10).toFixed(2); // `-` sign to match `handleCardClick`
        const rotateY = (x / 10).toFixed(2);

        tiltApi.start({
            transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1)`,
        });
    };

    const resetTilt = () => {
        tiltApi.start({
            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)',
        });
    };

    const applyJump = () => {
        // 위로 20px 점프 후 복귀
        jumpApi.start({
            transform: 'translate(-50%, -50%) translateY(-6px)', // 위로 이동
        });
        setTimeout(() => {
            jumpApi.start({
                transform: 'translate(-50%, -50%) translateY(0px)', // 원래 위치로 복귀
            });
        }, 100); // 200ms 후 원래 위치로 복귀
    };

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const jackpotAudio = new Audio('/sound/jackpot_start_sound.mp3');
    const soundAudio = new Audio('/sound/Sound.5.mp3');
    const clickAudio = new Audio('/sound/clicker_sound.wav');

    // 미리 오디오 로드 (iOS에서 딜레이 방지)
    jackpotAudio.preload = "auto";
    soundAudio.preload = "auto";
    clickAudio.preload = "auto";

    const playAudioWithContext = (audio, duration) => {
        if (audioCtx.state === "suspended") {
            audioCtx.resume().catch(error => console.error("AudioContext resume error:", error));
        }

        audio.play().catch(error => console.error("Audio play error:", error));

        setTimeout(() => {
            audio.pause();
            audio.currentTime = 0;
        }, duration);
    };

    const WhaleplayAudio = () => {
        if (sound) {
            playAudioWithContext(jackpotAudio, 10000);
        }
        setTimeout(() => {
            setJackpotWhale(true);
        }, 9000);
    };

    const playAudio = () => {
        playAudioWithContext(soundAudio, 3000);
    };

    const ClickAudio = () => {
        playAudioWithContext(clickAudio, 700);
    };


    const onClickWhale = (e) => {
        // requestAnimationFrame을 사용하여 오디오와 상태 업데이트를 지연 처리
        requestAnimationFrame(() => {
            if (sound) playAudio();
            const newGold = gold + jackpotAmt;

            // 골드 상태 업데이트
            dispatch(changeGold(newGold));

            // 이미지 위치를 텍스트에 적용
            const rect = e.target.getBoundingClientRect();
            setTextPosition({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX
            });

            // 이미지와 텍스트 표시 관리
            setJackpotWhale(false); // 이미지 숨기기
            setShowGoldText(true); // +1 텍스트 표시

            // 텍스트 일정 시간 후 사라지기
            setTimeout(() => {
                setShowGoldText(false);
            }, 1000); // 1초 후 사라짐

            if (haptic) handleVibration(10);

            // if (myData.id != "5824942771" && myData.id != "960163023" && myData.id != "5859629751" && myData.id != "8029479778") {
            ClickJackpot(clickBudgetId)
            // jackpotCheck = false;
            // }
        });
    };

    const checkTimeAndLog = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMin = now.getMinutes();
        const currentSec = now.getSeconds();

        if (currentMin == 0 && currentSec == 0) jackpotCheck = false;

        for (let i = 0; i < jackpot?.jackpotSlotRows?.length; i++) {
            let pot = jackpot.jackpotSlotRows[i];

            // 현재 시간 가져오기
            const now = new Date();
            const currentHour = now.getHours();
            const currentMin = now.getMinutes();
            const currentSec = now.getSeconds();

            // 문자열 시간("HH:MM:SS")을 분리하여 숫자로 변환
            const [startHour, startMin, startSec] = pot.start_time.split(':').map(Number);
            const [endHour, endMin, endSec] = pot.end_time.split(':').map(Number);

            // 현재 시간이 시작 시간 이후인지 확인
            const isAfterStart =
                currentHour > startHour ||
                (currentHour === startHour && currentMin > startMin) ||
                (currentHour === startHour && currentMin === startMin && currentSec >= startSec);

            // 현재 시간이 종료 시간 이전인지 확인
            const isBeforeEnd =
                currentHour < endHour ||
                (currentHour === endHour && currentMin < endMin) ||
                (currentHour === endHour && currentMin === endMin && currentSec < endSec);

            // 조건에 맞는지 확인

            if (isAfterStart && isBeforeEnd && !jackpotCheck && energy > 0 && pot.possible) {
                let random = Math.random();
                if (random < jackpot.winProbability / 100) {
                    console.log("**********당첨************")
                    jackpotCheck = true;
                    Jackpot()
                }
            }
        }
    };

    const Jackpot = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/jackpot/check', {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                WhaleplayAudio();
                setClickBudgetId(tmp?.data?.jackpotId ?? "");
                setJackpotAmt(tmp?.data?.reward ?? 0);
            }
            setTimeout(() => {
                jackpotCheck = false;
                setJackpotWhale(false);
            }, 20 * 1000)
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const ClickJackpot = async (id) => {
        await axios.post(process.env.REACT_APP_API + '/api/jackpot/win', {
            jackpotId: id
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setClickBudgetId("")
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    useEffect(() => {
        AOS.init();
    })

    return (
        <div className="main" style={{ paddingTop: adsHeightState === 1 || adsHeightState === 3 ? "55px" : "105px" }}>
            <MessageModal message={message} />
            {infoModal && (<AirdropModal setInfoModal={setInfoModal} upgrade={upgrade} setMessage={setMessage} />)}
            <div className="main-box">
                {
                    adsHeightState === 3 || adsHeightState === 0
                        ?
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={20}
                            pagination={{
                                clickable: true,
                                dynamicBullets: true,
                            }}
                            modules={[FreeMode, Autoplay, Pagination]}
                            loop={true}
                            autoplay={{
                                delay: 3000, // 2초 후에 다음 슬라이드로 이동
                                disableOnInteraction: false,
                            }}
                            speed={1000} // 슬라이드 이동 속도 (1초)

                            className="swiper ay_Swiper4 style_dot2"
                            style={{
                                width: "100%",
                                aspectRatio: "4/1",
                            }}
                        >
                            {
                                banner.map(function (a, i) {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="main-1">
                                                <div
                                                    className="main-ads"
                                                    style={{
                                                        width: "100%",
                                                        aspectRatio: "4/1",
                                                        // height: `100px`,
                                                        backgroundImage: `url(${process.env.REACT_APP_API}${a.ad_img})`,
                                                        backgroundSize: "cover", // 이미지 비율 유지하면서 div 안에 맞춤
                                                        backgroundPosition: "center",
                                                        backgroundRepeat: "no-repeat",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => window.open(a.ad_redirect_url, '_blank')}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                        :
                        ""
                }
                <div>
                    {jackpotWhale && (
                        <motion.img
                            src={
                                JackpotImg.filter((img) => jackpotAmt >= img.gold_rate) // 조건에 맞는 항목 필터링
                                    .sort((a, b) => b.gold_rate - a.gold_rate)[0]?.url || '' // 내림차순 정렬 후 첫 번째 항목 선택
                            }
                            style={{
                                position: 'absolute',
                                top: '30px',
                                left: '0',
                                width: '100px',
                                zIndex: '1000',
                            }}
                            initial={{ x: '100vw', y: '100px' }} // 오른쪽 화면 밖에서 시작
                            animate={{
                                x: '-300px', // 왼쪽 화면 밖으로 이동
                                y: [100, 70, 100, 70, 100], // 물결 모양으로 위아래로 움직임
                            }}
                            onClick={onClickWhale}
                            transition={{
                                duration: 10, // 10초 동안 이동
                                ease: 'linear', // 일정한 속도로 이동
                                y: {
                                    duration: 3, // y축 이동의 반복 주기
                                    repeat: Infinity,
                                    ease: 'linear',
                                },
                            }}
                        />
                    )}

                    <AnimatePresence>
                        {showGoldText && (
                            <>
                                <img src='/newImg/vfx_confetti.gif'
                                    style={{
                                        position: 'absolute',
                                        top: `${textPosition.top - 180}px`,
                                        left: `${textPosition.left - 130}px`,
                                        width: '400px',
                                        zIndex: 1000,
                                    }}
                                />
                                {/* <AnimationFireWork x={parseFloat(textPosition.left) + 50} y={parseFloat(textPosition.top) - 50} /> */}
                                <motion.div
                                    initial={{ opacity: 0, x: 10, y: -70 }}
                                    animate={{ opacity: 1, x: 10, y: -120 }}
                                    exit={{ opacity: 0 }}
                                    style={{
                                        position: 'absolute',
                                        top: textPosition.top,
                                        left: textPosition.left,
                                        fontSize: '40px',
                                        fontWeight: "bold",
                                        color: 'gold',
                                        zIndex: '1001',
                                    }}
                                    transition={{ duration: 1 }}
                                >
                                    +{jackpotAmt}
                                </motion.div>
                            </>
                        )}
                    </AnimatePresence>

                </div>
                <div className="main-2" style={{ paddingTop: adsHeightState === 3 || adsHeightState === 0 ? "20px" : "0" }}>
                    <div>
                        <div className="main-2-header">
                            <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none" }} />
                            <div className='fontNumber'>
                                <SlotCounter value={changeNum(gold)}
                                    duration={0.2}
                                    autoAnimationStart={false}
                                    sequentialAnimationMode
                                />
                            </div>
                        </div>
                        <div className="main-2-img"
                            ref={imgRef}
                            onPointerDown={handlePointerDown}
                            onPointerUp={resetTilt}>
                            {hearts.map((heart) => (
                                <div
                                    key={heart.id}
                                    alt="Heart"
                                    className='heart number'
                                    style={{ left: `${heart.x}px`, top: `${heart.y}px` }}>
                                    +{tapUpgradeValue}
                                </div>
                            ))}
                            <animated.img
                                ref={imageRef}
                                src={circleImg}
                                alt="Center"
                                className="center-img"
                                style={{
                                    ...tiltStyle,
                                    // width: '90%',
                                    width: '100%',
                                    minWidth: '280px',
                                    cursor: 'pointer',
                                }}
                                draggable="false" // 드래그 방지
                                onLoad={() => setCenterImgLoad(true)}
                            />
                            {
                                centerImgLoad && (
                                    <animated.img
                                        src={`${process.env.REACT_APP_API}${mySkin.skin_img}`}
                                        alt="Hamster"
                                        className="hamster-img"
                                        style={{
                                            ...jumpStyle,
                                        }}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="main-3">
                    <div>
                        <div className="main-3-1 fontNumber" style={{ gap: "7px" }}>
                            <img src="/img/lightning.png" className="main-3-1-img" style={{ pointerEvents: "none", width: "19px" }} />
                            <div>
                                <span>{changeNum(energy)}/{changeUnitsOrigial(limitUpgradeValue)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="main-3-1" style={{ gap: "7px", paddingRight: "20px" }} onClick={() => setInfoModal(true)}>
                        <img src="/img/boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: "33px" }} />
                        <div>{t('main_0')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const AnimationFireWork = ({ x, y }) => {
    const canvasRef = useRef(null);
    const fireworks = useRef([]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        class Particle {
            constructor(x, y, color, angle, speed, size, life) {
                this.x = x;
                this.y = y;
                this.color = color;
                this.angle = angle;
                this.speed = speed;
                this.size = size;
                this.life = life;
                this.opacity = 1;
            }

            update() {
                this.x += Math.cos(this.angle) * this.speed;
                this.y += Math.sin(this.angle) * this.speed;
                this.opacity -= 1 / this.life;
                this.size *= 0.98;
            }

            draw(ctx) {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fillStyle = this.color;
                ctx.globalAlpha = this.opacity;
                ctx.fill();
                ctx.closePath();
            }
        }

        class Firework {
            constructor(x, y, color) {
                this.particles = [];
                for (let i = 0; i < 500; i++) {
                    const angle = Math.random() * Math.PI * 2;
                    const speed = Math.random() * 4 + 1;
                    const size = Math.random() * 3 + 1;
                    const life = Math.random() * 80 + 50;
                    const colorVariation = `hsl(${Math.random() * 360}, 100%, 50%)`;
                    this.particles.push(new Particle(x, y, colorVariation, angle, speed, size, life));
                }
            }

            update() {
                this.particles = this.particles.filter((p) => p.opacity > 0);
                this.particles.forEach((p) => p.update());
            }

            draw(ctx) {
                this.particles.forEach((p) => p.draw(ctx));
            }
        }

        function addFirework(x, y) {
            fireworks.current.push(new Firework(x, y, `hsl(${Math.random() * 360}, 100%, 50%)`));
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            fireworks.current.forEach((fw, index) => {
                fw.update();
                fw.draw(ctx);
                if (fw.particles.length === 0) {
                    fireworks.current.splice(index, 1);
                }
            });
            requestAnimationFrame(animate);
        }

        addFirework(x, y); // 전달받은 위치에서 폭죽 발생
        animate();

        return () => {
            fireworks.current = [];
        };
    }, [x, y]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1000,
                pointerEvents: "none",
            }}
        />
    );
}

function AirdropModal({ setInfoModal, upgrade, setMessage }) {
    const { t } = useTranslation();

    let tapUpgrade = useSelector((state) => { return state.tapUpgrade.value })
    let limitUpgrade = useSelector((state) => { return state.limitUpgrade.value })

    let [detail, setDetail] = useState(false)
    let [clickData, setClickData] = useState("")

    let [nextTap, setNextTap] = useState([])
    let [nextLimit, setNextLimit] = useState([])

    useEffect(() => {
        let tap = upgrade["tab-plus"]
        let limit = upgrade["energy-limit"]

        for (let i = 0; i < tap.length; i++) {
            if (tapUpgrade == tap.length) {
                setNextTap({ "name": tap[0].up_type, "coin": "max" })
            }
            else if (tapUpgrade + 1 == tap[i].up_level) {
                setNextTap({ "name": tap[i].up_type, "coin": tap[i].up_price, "level": tap[i].up_level, "value": tap[i].up_value })
            }
        }
        for (let i = 0; i < limit.length; i++) {
            if (limitUpgrade == limit.length) {
                setNextLimit({ "name": limit[0].up_type, "coin": "max" })
            }
            else if (limitUpgrade + 1 == limit[i].up_level) {
                setNextLimit({ "name": limit[i].up_type, "coin": limit[i].up_price, "level": limit[i].up_level, "value": limit[i].up_value })
            }
        }
    }, [upgrade])

    return (
        <div className='modal'>
            {detail && (<AirdropModalItem setDetail={setDetail} setInfoModal={setInfoModal} clickData={clickData} nextTap={nextTap} nextLimit={nextLimit} setMessage={setMessage} />)}
            <div className='modal-background' onClick={() => setInfoModal(false)}></div>
            <div className='airdrop-modal' style={{ minHeight: "370px" }}>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setInfoModal(false)} />
                <img src="/img/boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '70px', marginBottom: "5px" }} />
                <div style={{ fontSize: '27px', fontWeight: "500", marginBottom: "15px" }}>{t('main_1')}</div>
                <div className='friend-list' style={{ gap: '10px', marginBottom: "10px" }} onClick={() => { setClickData("Multi tap"); setDetail(true) }}>
                    <img src='/img/tab_boost.png' style={{ width: "45px" }} />
                    <div className='friend-list-text'>
                        <div style={{ fontWeight: '500', fontSize: '14px' }}>
                            <span style={{ color: "#ffbb3f", marginRight: "6px", fontWeight: "bold" }}>
                                {
                                    nextTap.coin == "max"
                                        ?
                                        "Lv.max"
                                        :
                                        `Lv.${tapUpgrade}`
                                }
                            </span>
                            {t('main_2')}
                        </div>
                        {
                            nextTap.coin == "max"
                                ?
                                ""
                                :
                                <div className='friend-list-text-1'>
                                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                                    <span className='fontNumber' style={{ marginRight: "3px" }}>{changeNum(nextTap.coin)}</span>
                                </div>

                        }
                    </div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
                <div className='friend-list' style={{ gap: '10px', marginBottom: "10px" }} onClick={() => { setClickData("Energy limit"); setDetail(true) }}>
                    <img src='/img/energy_boost.png' style={{ width: "45px" }} />
                    <div className='friend-list-text'>
                        <div style={{ fontWeight: '500', fontSize: '14px' }}>
                            <span style={{ color: "#ffbb3f", marginRight: "6px", fontWeight: "bold" }}>
                                {
                                    nextLimit.coin == "max"
                                        ?
                                        "Lv.max"
                                        :
                                        `Lv.${limitUpgrade}`
                                }
                            </span>
                            {t('main_3')}
                        </div>
                        {
                            nextLimit.coin == "max"
                                ?
                                ""
                                :
                                <div className='friend-list-text-1'>
                                    <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                                    <span className='fontNumber' style={{ marginRight: "3px" }}>{changeNum(nextLimit.coin)}</span>
                                </div>
                        }
                    </div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
            </div>
        </div>
    )
}

function AirdropModalItem({ setDetail, setInfoModal, clickData, nextTap, nextLimit, setMessage }) {
    const { t } = useTranslation();
    let gold = useSelector((state) => { return state.gold.value })
    let energy = useSelector((state) => { return state.energy.value })
    let tapUpgrade = useSelector((state) => { return state.tapUpgrade.value })
    let limitUpgrade = useSelector((state) => { return state.limitUpgrade.value })
    let tapUpgradeValue = useSelector((state) => { return state.tapUpgradeValue.value })
    let limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    let JWT = useSelector((state) => { return state.JWT.value })

    let dispatch = useDispatch()

    const [buyBtn, setBuyBtn] = useState(false)

    let item = clickData == "Multi tap" ? tapUpgrade : limitUpgrade
    let up = clickData == "Multi tap" ? nextTap : nextLimit
    let value = clickData == "Multi tap" ? tapUpgradeValue : limitUpgradeValue


    const UpgradeLevel = async () => {
        setBuyBtn(true)
        if (up.coin != "max" && gold - up.coin >= 0) {
            await axios.post(process.env.REACT_APP_API + '/api/upgrade', {
                item: up.name,
                level: up.level
            }, {
                headers: { Authorization: `Bearer ${JWT}` }
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code == 1000) {
                    setTimeout(() => {
                        if (clickData == "Multi tap") {
                            dispatch(checkTapUpgrade(up.level))
                            dispatch(checkTapUpgradeValue(up.level))
                            setMessage({ "code": 0, "msg": `${t('message_0')} ${up.level} ${t('message_0_1')}` })
                        }
                        else {
                            dispatch(changeEnergy(energy + up.value - limitUpgradeValue))
                            dispatch(checkLimitUpgrade(up.level))
                            dispatch(checkLimitUpgradeValue(up.value))
                            setMessage({ "code": 0, "msg": `${t('message_1')} ${up.level} ${t('message_1_1')}` })
                        }
                        dispatch(changeAlramModal())
                        dispatch(changeGold(gold - up.coin))
                        setBuyBtn(false)
                        setInfoModal(false)
                    }, 1000)
                }
                else {
                    setTimeout(() => {
                        setBuyBtn(false)
                    }, 1000)
                }
            }).catch((error) => {
                if (error?.status === 999) {
                    dispatch(checkDuplicateLogins(true))
                }
                else {
                    console.log(error)
                }
            })
        }
    };

    return (
        <div className='modal'>
            <div className='modal-background' onClick={() => setInfoModal(false)}></div>
            <div className='airdrop-modal' style={{ minHeight: "370px" }}>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setDetail(false)} />
                {
                    clickData == "Multi tap"
                        ?
                        <img src="/img/tab_boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '80px', marginBottom: "5px" }} />
                        :
                        <img src="/img/energy_boost.png" className="main-3-1-img" style={{ pointerEvents: "none", width: '80px', marginBottom: "5px" }} />
                }
                <div style={{ fontSize: '27px', fontWeight: "500", marginBottom: "15px" }}>{clickData}</div>
                {
                    up.coin == "max"
                        ?
                        <div style={{ marginBottom: "5px", display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                            Lv.{up.coin}
                        </div>
                        :
                        <div className='fontNumber' style={{ marginBottom: "5px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src="/newImg/icon_main_diamond.png" className="img_diamond" alt="Diamond" style={{ pointerEvents: "none", width: "18px", marginRight: "3px" }} />
                            {changeNum(up.coin)}
                        </div>
                }
                {
                    up.coin == "max"
                        ?
                        <div style={{ height: "50px" }}></div>
                        :
                        <>
                            <div style={{ marginBottom: "5px", display: "flex", alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                                Lv.{item}<ChevronRight size={20} style={{ margin: "0px 20px" }} />Lv.{item + 1}
                            </div>
                            <div className='fontNumber' style={{ marginBottom: "15px", display: "flex", alignItems: 'center', justifyContent: 'center', color: '#ffbb3f' }}>
                                {changeNum(value)}<ChevronRight size={20} style={{ margin: "0px 20px" }} />{changeNum(up.value)}
                            </div>
                        </>
                }
                <div style={{ fontSize: "13px", marginBottom: '20px' }}>
                    {
                        clickData == "Multi tap"
                            ?
                            t('main_4')
                            :
                            t('main_5')
                    }
                </div>
                {
                    up.coin == "max"
                        ?
                        ""
                        :
                        <div className='modal-airdrop-btn' onClick={() => { !buyBtn && UpgradeLevel() }}>
                            {
                                buyBtn
                                    ?
                                    <BeatLoader size={13} color="#003577" />
                                    :
                                    t('main_6')
                            }
                        </div>
                }
            </div>
        </div>
    )
}

export default Main;
